import React, { useRef, useState, useEffect } from "react";
import AnvilSignatureModal from '@anvilco/react-signature-modal'
import '@anvilco/react-signature-modal/dist/styles.css'
import { useFormContext } from "../../utils/FormContext.jsx"
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../utils/AuthContext/AuthContext.jsx';
import config from '../../utils/config.js'


const PacketSign = () => {
    const [signingURL, setSigningURL] = useState('');
    // const [signerEid, setSignerEid] = useState('');
    // const [clientId, setClientId] = useState('');
    const { formData, formId, currentFormId, propertyData } = useFormContext(); 
    const [packetEid, setPacketEid] = useState(null); 
    const [documentGroupEid, setDocumentGroupEid] = useState(null);
    const [packetDetails, setPacketDetails] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [eventObject, setEventObject] = useState(null);
    const { token, user } = useAuth();
    const navigate = useNavigate();

    // console.log("formData on PacketSign mount:", formData);
    // console.log("Property Data on PacketSign mount:", propertyData);
    // console.log("FormId on PacketSign mount:", currentFormId);

    useEffect(() => {
        // Replace 'http://localhost:5000' with your server's URL
        // console.log("Create Packet called: ", formData, propertyData);
        const body = propertyData ? {formData, propertyData} : {formData};
        // fetch('http://localhost:5000/api/packet/create', {
          fetch(`${config.apiBaseUrl}/packet/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
        .then(response => response.json())
        .then(data => {
          setPacketEid(data.data.data.createEtchPacket.eid);
          setDocumentGroupEid(data.data.data.createEtchPacket.documentGroup.eid);
          setPacketDetails(data.data.data.createEtchPacket);
          // console.log('PacketEid:', data.data.data.createEtchPacket.eid);
          // console.log('PacketEid:', data.data.data.createEtchPacket);
        })
        .catch((error) => {
            console.error('There was an error!', error);
        });
      }, []); 

  useEffect(() => {
    // Check if packetEid is available before making the request
    if (packetEid && !isModalOpen) {
      // Extract the first signer from the documentGroup
      const signer = packetDetails?.documentGroup?.signers[0];
  
      // Make a POST request to the /packet/sign endpoint
      // fetch('http://localhost:5000/api/packet/sign', {
        fetch(`${config.apiBaseUrl}/packet/sign`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: signer?.eid, // Use signer.eid as userId
          signerEid: signer?.eid,
          clientId: signer?.aliasId,
          etchPacketEid: packetDetails?.eid,
          documentGroupEid: packetDetails?.documentGroup?.eid,
        }),
      })
      .then(response => response.json())
      .then(data => {
        // console.log('Data from /packet/sign:', data);
        if (data.statusCode === 200) {
          
          setSigningURL(data.url);
          // console.log("Signing URL:", data.url+"?withinIframe=true");
          setIsModalOpen(true);
          // console.log('isModalOpen:', isModalOpen);
        } else {
          console.error('Error generating sign URL:', data.error);
        }
      })
      .catch((error) => {
        console.error('There was an error!', error);
      });
    }
  }, [packetEid, isModalOpen]); // Depend on packetEid so the effect runs whenever packetEid changes

  useEffect(() => {
    if (packetEid) {
      // fetch(`http://localhost:5000/api/formdata/${currentFormId}`, {
        fetch(`${config.apiBaseUrl}/formdata/${currentFormId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            etchPacketEid: packetEid,
        }),
      })
      .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // console.log('Success:', data);
      })
      .catch(e => {
        setError(e.toString());
      });
    }
  }, [packetEid]);

// Close the modal when signerComplete event is received
  useEffect(() => {
    if (eventObject?.action === 'signerComplete') {
      setIsModalOpen(false);
      navigate(`/packet/finish?etchPacketEid=${eventObject.etchPacketEid}&documentGroupEid=${documentGroupEid}&formId=${currentFormId}`);
    }
  }, [eventObject]);

  const renderSignModal = () => (
      <AnvilSignatureModal
        iframeURL={signingURL}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onEvent={(event) => {
            // console.log('Event object:', event);
            setEventObject(event);
        }}
        // anvilURL = "http://localhost:5173"
      />
  );
  
  return (
    <div >
      <object id="pdfObject" type="application/pdf" className='w-[0px] h-[0px]'></object>
      {renderSignModal()}
    </div>
  );
}

export default PacketSign; 